import { gql } from "@apollo/client";

export const GET_SERVICE_BY_ID = gql`
  query ($serviceId: String!) {
    getServiceById(serviceId: $serviceId) {
      id
      orgId
      name
      status
      alternateName
      description
      url
      email
      interpretationServices
      applicationProcess
      waitTime
      cost
      accreditations
      licenses
      subOpCategory
      opCategory
      requiredDocuments
      paymentsAccepted
      eligibilities
      fundings
      serviceAreas
      languages
      draft
      isPublished
      createdAt
      updatedAt
      overallCapacity
      currentlyServing
      autoScreen
      location {
        id
        name
        transportation
        latitude
        longitude
        zipCode
        accessibiltyForDisabilities
        languages
        address
        city
        region
        stateOrProvince
        postalCode
        country
        schedule
      }
      contacts {
        id
        firstName
        lastName
        title
        department
        email
      }
      phones {
        id
        number
        extension
        type
        language
        description
      }
    }
  }
`;
